import { Card, CardHeader, CardTitle, CardContent, CardDescription, CardAction, CardFooter } from '../../shadcnComponents/ui/card';
import { Button } from '../../shadcnComponents/ui/button';
import { XMarkIcon } from '@heroicons/react/24/solid';

export function RetranscribeElement(props) {

    function retranscribeClicked() {
        props.transcribeSelected()
        props.unsetNameToRetranscribe()
        document.getElementById('retranscribe-file').classList.add('hidden');
    }

    function cancelRetranscribeClicked() {
        props.unsetNameToRetranscribe()
        document.getElementById('retranscribe-file').classList.add('hidden');
    }

    return (
        <div id='retranscribe-file' className="hidden fixed z-10 w-screen h-screen top-0 left-0 bg-secondary-background flex items-center justify-center">
            <Card className='w-[40rem]'>
                <CardHeader>
                    <CardTitle>Το αρχείο {props.fileToRetranscribe.name} έχει επιλεγεί για μεταγραφή</CardTitle>
                    <CardDescription>
                        Επιθυμείτε να προχωρήσετε;
                    </CardDescription>
                    <CardAction>
                        <Button onClick={() => { cancelRetranscribeClicked() }} variant="link">
                            <XMarkIcon className='size-6' />
                        </Button>
                    </CardAction>
                </CardHeader>
                <CardContent>
                    Εάν απομαγνητοφωνήσετε εκ νέου το αρχείο θα <b>διαγραφεί οριστικά</b> η υπάρχουσα απομαγνητοφώνηση και όλη η επεξεργασία που έχει γίνει σε αυτή.
                </CardContent>
                <CardFooter className='gap-5 w-full justify-end'>
                    <Button variant={'yes'} onClick={() => { retranscribeClicked() }}>
                        Ναι
                    </Button>
                    <Button variant={'no'} onClick={() => { cancelRetranscribeClicked() }}>
                        Όχι
                    </Button>
                </CardFooter>
            </Card>
        </div>
    )
}

export default RetranscribeElement